// Date helpers for LOCAL display.
// A date-only ISO string (YYYY-MM-DD) is parsed by JS as UTC midnight, which then
// renders a day earlier in negative-offset timezones (e.g. US Central). Building
// the Date from its parts keeps it in local time so it reads back as entered.
export function parseLocalDate(s) {
  if (!s) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s).trim());
  return m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(s);
}

export function fmtDate(s, opts = { month: "short", day: "numeric", year: "numeric" }) {
  const d = parseLocalDate(s);
  return d ? d.toLocaleDateString(undefined, opts) : "";
}

// Timestamps (an instant in time: created/updated/entered/last visit/activity) shown
// in America/Chicago. A bare UTC date-only string is treated as that instant too,
// so it rolls to the correct Chicago calendar day.
export function fmtCt(s, opts = { month: "short", day: "numeric", year: "numeric" }) {
  if (!s) return "";
  const d = new Date(s);
  return isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-US", { timeZone: "America/Chicago", ...opts });
}

export function fmtCtTime(s, opts = { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) {
  if (!s) return "";
  const d = new Date(s);
  return isNaN(d.getTime()) ? "" : d.toLocaleString("en-US", { timeZone: "America/Chicago", ...opts });
}
